import { render, staticRenderFns } from "./SupiMainPage.vue?vue&type=template&id=32322861&scoped=true&"
import script from "./SupiMainPage.vue?vue&type=script&lang=js&"
export * from "./SupiMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32322861",
  null
  
)

export default component.exports